export const employees = [
  { id: 1, name: 'John Doe', age: 28, department: 'IT', designation: 'Developer', salary: 50000, 
    location: 'Pune' },
  { id: 2, name: 'Jane Smith', age: 32, department: 'HR', designation: 'Manager', salary: 60000, 
    location: 'Mumbai' },
  { id: 3, name: 'Michael Johnson', age: 26, department: 'Finance', designation: 'Analyst', 
    salary: 45000, location: 'Delhi' },
  { id: 4, name: 'Emily Davis', age: 30, department: 'Marketing', designation: 'Executive', 
    salary: 48000, location: 'Bangalore' },
  { id: 5, name: 'William Brown', age: 35, department: 'IT', designation: 'Team Lead', salary: 70000, 
    location: 'Pune' },
  { id: 6, name: 'Olivia Wilson', age: 29, department: 'Finance', designation: 'Analyst', salary: 46000, 
    location: 'Delhi' },
  { id: 7, name: 'James Taylor', age: 31, department: 'HR', designation: 'Executive', salary: 52000, 
    location: 'Mumbai' },
  { id: 8, name: 'Sophia Anderson', age: 27, department: 'Marketing', designation: 'Coordinator', 
    salary: 43000, location: 'Bangalore' },
  { id: 9, name: 'Benjamin Thomas', age: 33, department: 'IT', designation: 'Developer', salary: 55000, 
    location: 'Pune' },
  { id: 10, name: 'Charlotte Lee', age: 28, department: 'HR', designation: 'Assistant', salary: 40000, 
    location: 'Mumbai' },
  { id: 11, name: 'Daniel Martin', age: 34, department: 'Finance', designation: 'Manager', salary: 62000, 
    location: 'Delhi' },
  { id: 12, name: 'Grace Harris', age: 26, department: 'Marketing', designation: 'Executive', salary: 47000, 
    location: 'Bangalore' }
];